module.exports = __webpack_public_path__ + "static/media/18ECA16.54980547.jpg";